import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState = {
  modules: [],
  accessMappingModules: [],
  isLoaded: false,
  error: [],
};

export const fetchModules: any = createAsyncThunk(
  "content/fetchModules",
  async ({ RoleId }: any) => {
    const res = await axios("slpapp/Menu/getMenuPermissionsByRole", {
      params: { RoleId: RoleId },
    });

    const data = await res?.data?.data;
    return data;
  }
);

export const fetchModulesForAccessMapping: any = createAsyncThunk(
  "content/fetchModulesForAccessMapping",
  async ({ RoleId }: any) => {
    const res = await axios("slpapp/Menu/getMenuPermissionsByRole", {
      params: { RoleId: RoleId },
    });
    const data = await res?.data?.data;
    return data;
  }
);

export const navbarSlice = createSlice({
  name: "navbar",
  initialState,
  reducers: {
    updateNavbar(state, action) {
      state.accessMappingModules = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchModules.pending, (state) => {
      state.isLoaded = true;
    });
    builder.addCase(fetchModules.fulfilled, (state, action) => {
      state.isLoaded = false;
      state.modules = action.payload;
    });
    builder.addCase(fetchModules.rejected, (state, action) => {
      state.isLoaded = false;
      state.error = action.error.message;
    });

    builder.addCase(fetchModulesForAccessMapping.pending, (state) => {
      state.isLoaded = true;
    });
    builder.addCase(fetchModulesForAccessMapping.fulfilled, (state, action) => {
      state.isLoaded = false;
      state.accessMappingModules = action.payload;
    });
    builder.addCase(fetchModulesForAccessMapping.rejected, (state, action) => {
      state.isLoaded = false;
      state.error = action.error.message;
    });
  },
});

export const { updateNavbar } = navbarSlice.actions;

export default navbarSlice.reducer;
